import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header/Header";

interface HeaderContainerProps {
  loggedIn: boolean;
  onLogin: () => void;
  onLogout: () => void;
  hideAuthButtons?: boolean;
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({
  loggedIn,
  onLogin,
  onLogout,
  hideAuthButtons,
}) => (
  <>
    <Header
      loggedIn={loggedIn}
      hideAuthButtons={hideAuthButtons}
      onLogin={onLogin}
      onLogout={onLogout}
    />
    <Outlet />
  </>
);

export default HeaderContainer;
